import { Controller } from '@hotwired/stimulus';
import AutoNumeric from 'autonumeric';

export default class extends Controller {
  static targets = [
    'documentCurrencyInput',
    'settlementCurrencyInput',
    'settlementCurrencyInputWrapper',
    'amountDueInput',
    'issueDateInput',
    'notesInput',
  ];

  // FIXME: Stimulus should only listen for standard DOM events, refactor after removing jQuery
  settlementCurrencyInputTargetConnected(target) {
    $(target).offon('change', () => this.fire());
  }

  proceed() {
    if (!this.issueDateInputTarget.value) return false;
    if (!this.amountDueInputTarget.value) return false;
    if (this.documentCurrencyInputTarget.value === 'PLN') return false;

    return this.settlementCurrencyInputTarget.value === 'PLN';
  }

  async fire() {
    if (!this.proceed()) return;

    const date = new Date(this.issueDateInputTarget.value);
    await this.fetchExchangeRates('C', this.previousDay(date), 4);
  }

  async fetchExchangeRates(type, date, attempts_left) {
    if (attempts_left === 0) return;

    const response = await window.fetch(this.url(type, date));

    if (response.ok) {
      this.writeInfo(await response.json(), type);
    } else if (response.status === 404) {
      if (type === 'C') {
        await this.fetchExchangeRates('A', date, attempts_left);
      } else {
        await this.fetchExchangeRates(
          'C',
          this.previousDay(date),
          attempts_left - 1,
        );
      }
    }
  }

  url(type, date) {
    const params = `${type}/${this.documentCurrencyInputTarget.value}/${
      date.toISOString().split('T')[0]
    }`;
    return `https://api.nbp.pl/api/exchangerates/rates/${params}/?format=json`;
  }

  previousDay(date) {
    date.setDate(date.getDate() - 1);
    return date;
  }

  writeInfo(data, type) {
    const rate_data = data.rates[0];
    const exchange_rate =
      (type === 'C' && rate_data.ask) || (type === 'A' && rate_data.mid);

    const amount = AutoNumeric.format(this.amountDue() * exchange_rate, {
      decimalCharacter: ',',
      digitGroupSeparator: ' ',
    });

    const message =
      `Tabela kursów NBP: ${rate_data.no}, ` +
      `kurs sprzedaży ${data.code}: ${exchange_rate
        .toString()
        .replace('.', ',')}; ` +
      `kwota: ${amount} PLN`;

    this.writeToHint(message);
    this.writeToNotes(message);
  }

  amountDue() {
    return AutoNumeric.getNumber(this.amountDueInputTarget);
  }

  writeToHint(message) {
    let message_element = document.getElementById('exchange_rate_message_hint');

    if (!message_element) {
      message_element = document.createElement('div');
      message_element.classList.add('custom_hint');
      message_element.id = 'exchange_rate_message_hint';
      this.settlementCurrencyInputWrapperTarget
        .getElementsByClassName('input')[0]
        .after(message_element);
    }

    message_element.innerHTML = message;
  }

  writeToNotes(message) {
    this.notesInputTarget.value = `${message}\n\n${this.notesInputTarget.value}`;
  }
}
